import classNames from "classnames";
import type React from "react";
import type { ReactElement } from "react";
import { useComponentState } from "../../../utils/customHook.util";
import "./FullScreenOverlay.css";
import HandleClicksOutside from "../../HandleClicksOutside";
import { Flex } from "../Flex";

export type BucketSize = "minimized" | "maximized";
export type BucketProps = {
    minimize: () => void;
    maximize: () => void;
    size: BucketSize;
};
type Bucket = (props: BucketProps) => ReactElement | null;

type Props = {
    className?: string;
    children: React.ReactNode;
    bucket?: Bucket;
};

type State = {
    bucketSize: BucketSize;
};

function Bucket(props: { bucket: Bucket }) {
    const { bucket } = props;
    const { state, setState } = useComponentState<State>({
        bucketSize: "minimized",
    });

    return (
        <HandleClicksOutside
            onClickOutside={() => {
                setState({ bucketSize: "minimized" });
            }}
            className={classNames("full-screen-overlay__bucket", {
                "full-screen-overlay__bucket--minimized":
                    state.bucketSize === "minimized",
                "full-screen-overlay__bucket--maximized":
                    state.bucketSize === "maximized",
            })}
        >
            {bucket({
                size: state.bucketSize,
                minimize: () => {
                    setState({ bucketSize: "minimized" });
                },
                maximize: () => {
                    setState({ bucketSize: "maximized" });
                },
            })}
        </HandleClicksOutside>
    );
}

function FullScreenOverlay(props: Props) {
    const { className, children, bucket } = props;

    return (
        <div className={classNames("full-screen-overlay", className)}>
            <div className="full-screen-overlay__container">
                <Flex.Column className="full-screen-overlay__content">
                    {children}
                </Flex.Column>
            </div>
            {bucket && <Bucket bucket={bucket} />}
        </div>
    );
}

export default FullScreenOverlay;
